module.exports = __webpack_public_path__ + "static/img/8.b9e5d1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/8.png
// module id = UYHw
// module chunks = 0